export const caffeineRecommendationPeriodTime = 1000 * 60 * 60 * 8
